<i18n>
{
	"en": {
		"vendor": "Vendor",
		"allVendors": "All vendors"
	},
	"no": {
		"vendor": "Leverandør",
		"allVendors": "Alle Leverandører"
	}
}
</i18n>

<template>
	<t-form-group>

		<t-multiselect
			ref="input"
			:label="$t('vendor')"
			:allItems="vendors"
			:selectedItems="selectedItems"
			:placeholder="$t('allVendors')"
			:itemKeys="['name', 'vendorNumber']"
			closeOnSelect
			v-bind="$attrs"
			@select="addVendor"
			@set:selected="setVendors"
		/>

		<t-tag-container
			v-if="hasItems(selectedItems)"
			:items="selectedItems"
			displayKey="name"
			@change="setVendors"
			@tag-click="tagClick"
		>
			<template v-slot="{ item }">
				<t-location-tag-inner :item="item" displayKey="name" />
			</template>
		</t-tag-container>

	</t-form-group>
</template>

<script>
import { mapActions } from './store/vendors.store.js';

export default {
	name: 'VendorsMultiSelect',

	props: {
		selectedItems: Array,
	},

	data() {
		return {
			searchString: '',
			vendors: [],
		};
	},

	async created() {
		this.vendors = await this.statelessGetVendors();
	},

	methods: {
		...mapActions(['statelessGetVendors']),

		addVendor(vendor) {
			let alreadyAdded = this.selectedItems.some(x => x.id === vendor.id);
			if (alreadyAdded) return;
			this.setVendors([...this.selectedItems, vendor]);
		},

		setVendors(vendors) {
			this.$emit('change', vendors);
		},

		tagClick(event) {
			this.$emit('tag-click', event);
		},

		hasItems(array) {
			return array && array.length;
		},
	}
};
</script>